import axios from "axios"
import { apiURL } from "../config"


export const getCategories = async () => {
  try {
    const response = await axios.get(`${apiURL}category`)
    return response.data || {}
  } catch (error) {
    return error
  }
}

export const createCategory = async (body) => {
  try {
    const response = await axios.post(`${apiURL}category`, body)
    return response.data || {}
  } catch (error) {
    return error
  }
}
